import { useQuery } from '@tanstack/react-query';
import { getFeaturesSummary } from '../../../services/monitor/features/MonitorFeaturesService';
import { GET_FEATURES_SUMMARY } from '../../../query/monitor/features/keys';
import { PromptFeaturesSummaryItem } from '../../../../models/monitor/ResponseFeatures';

export interface FeaturesSummaryParams {
  projectId: number;
  from: Date | null;
  to: Date | null;
  models?: string[];
  promptIds?: number[];
}

export const useGetFeaturesSummary = (params: FeaturesSummaryParams | null) => {
  const fromTimestamp = params?.from?.getTime() ?? null;
  const toTimestamp = params?.to?.getTime() ?? null;

  const query = useQuery<PromptFeaturesSummaryItem[]>({
    queryKey: [
      GET_FEATURES_SUMMARY,
      params?.projectId,
      fromTimestamp,
      toTimestamp,
      params?.models,
      params?.promptIds,
    ],
    queryFn: () => {
      if (!params || !params.from || !params.to) {
        throw new Error('Params with dates are required');
      }
      return getFeaturesSummary(params.projectId, params.from, params.to, params.models, params.promptIds);
    },
    staleTime: 1000 * 60 * 5,
    gcTime: 1000 * 60 * 30,
    refetchOnWindowFocus: false,
    enabled: !!params && !!params.from && !!params.to && !!params.projectId,
  });

  return {
    featuresSummary: query.data ?? null,
    isLoading: query.isLoading,
    isError: query.isError,
    refetch: query.refetch,
  };
};
